<div class="kotelezo">
  <h2 class="fo-cim">Kötelező nyomtatványok</h2>
  <p class="halvany">
    A 20/2012. (VIII. 31.) EMMI rendelet 94. §-a szerinti iskolai nyomtatványok, a rendszer adataiból.
    Nyisd le, add meg, amit kér, és a nyomtatvány PDF-ben nyílik meg.
    <ng-container *ngIf="tanev">Tanév: {{ tanev.nev }}.</ng-container>
  </p>
  <p class="halvany">
    Minden nyomtatvány az intézmény aktív tanúsítványával <b>elektronikusan aláírva</b> készül (időbélyeggel, ha az Aláírás-beállításban be van kapcsolva),
    és a <b>Generált dokumentumok</b> közé kerül (típus: Kötelező nyomtatvány). Ugyanazokkal a beállításokkal újra elkészítve a korábbi példány „régi verzió” lesz.
  </p>

  <!-- A 94. § teljes nyomtatványlistája (backend/nyomtatvanyok.js KOTELEZO_94): mi készül itt, mi máshol, mi nem. -->
  <div class="lefedettseg">
    <h3 class="al-cim">Kötelező nyomtatványok lefedettsége (94. §)</h3>
    <ng-container *ngIf="lefedettseg as L">
      <div class="osszesito">
        <span class="allapot generalt">Itt készül: {{ L.osszesito['generalt'] || 0 }}</span>
        <span class="allapot mashol">Máshol készül: {{ L.osszesito['mashol'] || 0 }}</span>
        <span class="allapot nincs">Nem készül: {{ L.osszesito['nincs'] || 0 }}</span>
        <span class="allapot hatalyon_kivul" *ngIf="L.osszesito['hatalyon_kivul']">Hatályon kívül: {{ L.osszesito['hatalyon_kivul'] }}</span>
      </div>
      <div class="tabla-keret">
        <table class="lef-tabla">
          <thead>
            <tr><th class="sz">Pont</th><th>Nyomtatvány (a rendelet szövegével)</th><th>Állapot</th><th>Hol készül / miért nem</th><th>Legutóbb tárolt</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let x of L.tetelek" [class.kattinthato]="kattinthato(x)" [class.halvany-sor]="x.allapot === 'hatalyon_kivul'"
                (click)="kattinthato(x) && ugras(x)" [attr.tabindex]="kattinthato(x) ? 0 : null" (keyup.enter)="kattinthato(x) && ugras(x)">
              <td class="sz">{{ x.sorszam }}.</td>
              <td>{{ x.megnevezes || '—' }}<span class="jogalap" *ngIf="x.tartalom">{{ x.tartalom }}</span></td>
              <td><span class="allapot" [ngClass]="x.allapot">{{ ALLAPOT_NEV[x.allapot] }}</span></td>
              <td>
                <ng-container *ngIf="kattinthato(x)">
                  <a class="ugras">{{ hova(x) }}<ion-icon [name]="x.allapot === 'mashol' ? 'open-outline' : 'arrow-down-outline'"></ion-icon></a>
                </ng-container>
                <span *ngIf="x.ok" class="halvany-szoveg">{{ x.ok }}</span>
                <div *ngIf="x.megjegyzes" class="halvany-szoveg">{{ x.megjegyzes }}</div>
              </td>
              <td class="kicsi">
                <ng-container *ngIf="x.allapot === 'generalt'">{{ x.legutobb || 'még nem készült' }}<span *ngIf="x.peldany"> ({{ x.peldany }} érvényes példány)</span></ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="halvany kicsi">
        Forrás: <a [href]="L.forras.url" target="_blank" rel="noopener">{{ L.forras.jogszabaly }}</a> (a {{ L.forras.idoallapot }}-tól hatályos szöveg, olvasva: {{ L.forras.olvasva }}).
        A sorra kattintva a nyomtatványhoz ugrik, vagy arra az oldalra visz, ahol készül.
      </p>
    </ng-container>
    <ion-note color="medium" *ngIf="!lefedettseg && lefedettsegHiba">{{ lefedettsegHiba }}</ion-note>
  </div>

  <ng-container *ngFor="let cs of csoportLista">
    <div class="csoport-cim"><ion-icon [name]="cs.ikon"></ion-icon>{{ cs.cim }}</div>
    <ng-container *ngFor="let n of cs.elemek">
      <!-- Nincs mit megadni: a gomb közvetlenül a sorban (nem kell lenyitni). -->
      <ion-item *ngIf="!n.mezok?.length" lines="full" class="egyszeru" [id]="'nyomtatvany-' + n.id" [class.kiemelt]="kiemelt === n.id">
        <ion-label class="ion-text-wrap">
          <h3>{{ n.cim }} <span class="jogalap">{{ n.jogalap }}</span></h3>
          <p>{{ n.leiras }}</p>
        </ion-label>
        <ion-button slot="end" *ngIf="!n.link" color="success" (click)="keszit(n)" [disabled]="fut[n.id] || !jogosult">
          <ion-icon slot="start" name="document-text-outline"></ion-icon>{{ fut[n.id] ? 'Készül…' : 'PDF' }}
        </ion-button>
        <ion-button slot="end" *ngIf="n.link" fill="outline" (click)="keszit(n)">
          <ion-icon slot="start" name="open-outline"></ion-icon>{{ n.link.cimke }}
        </ion-button>
      </ion-item>
      <!-- Paraméteres nyomtatvány: lenyitva adható meg, amit kér. -->
      <ion-accordion-group *ngIf="n.mezok?.length" [id]="'nyomtatvany-' + n.id" [class.kiemelt]="kiemelt === n.id"
                           [value]="nyitva[n.id]" (ionChange)="nyitasValt(n, $event)">
        <ion-accordion [value]="n.id">
          <ion-item slot="header" lines="full">
            <ion-label class="ion-text-wrap">
              <h3>{{ n.cim }} <span class="jogalap">{{ n.jogalap }}</span></h3>
              <p>{{ n.leiras }}</p>
            </ion-label>
          </ion-item>
          <div slot="content" class="tartalom">
            <div class="mezok">
              <ng-container *ngFor="let m of n.mezok"><ng-container *ngIf="latszik(n, m)">
                <ion-select *ngIf="m.tipus === 'osztaly'" [label]="m.cimke" label-placement="stacked" interface="popover"
                            [(ngModel)]="ertek[n.id][m.kulcs]" (ionChange)="osztalyValt(n.id)">
                  <ion-select-option *ngIf="!m.kotelezo" [value]="''">—</ion-select-option>
                  <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">{{ o.nev }}</ion-select-option>
                </ion-select>
                <ion-select *ngIf="m.tipus === 'csoport'" [label]="m.cimke" label-placement="stacked" interface="popover" [(ngModel)]="ertek[n.id][m.kulcs]">
                  <ion-select-option *ngFor="let c of (m.szuro === 'egyeb' ? egyebCsoportok : m.szuro === 'tanorai' ? tanoraiCsoportok : csoportok)" [value]="c.id">{{ c.nev }}{{ c.egyeb ? ' (' + (c.tipus_nev || 'egyéb foglalkozás') + ')' : '' }}</ion-select-option>
                </ion-select>
                <ion-select *ngIf="m.tipus === 'tanulo'" [label]="m.cimke" label-placement="stacked" interface="alert" [multiple]="!!m.tobb"
                            [(ngModel)]="ertek[n.id][m.kulcs]" [disabled]="!tanulok(n.id).length">
                  <ion-select-option *ngIf="!m.kotelezo && !m.tobb" [value]="''">—</ion-select-option>
                  <ion-select-option *ngFor="let t of tanulok(n.id)" [value]="t.oktazon">{{ t.nev }}</ion-select-option>
                </ion-select>
                <ion-select *ngIf="m.tipus === 'tantargy'" [label]="m.cimke" label-placement="stacked" interface="alert" [multiple]="!!m.tobb"
                            [(ngModel)]="ertek[n.id][m.kulcs]" [disabled]="!tantargyak(n.id).length">
                  <ion-select-option *ngFor="let t of tantargyak(n.id)" [value]="t">{{ t }}</ion-select-option>
                </ion-select>
                <ion-select *ngIf="m.tipus === 'valaszt'" [label]="m.cimke" label-placement="stacked" interface="popover" [(ngModel)]="ertek[n.id][m.kulcs]"
                            [placeholder]="m.alapNelkul ? 'Válassz…' : ''">
                  <ion-select-option *ngFor="let o of m.opciok" [value]="o.ertek">{{ o.nev }}</ion-select-option>
                </ion-select>
                <ion-input *ngIf="m.tipus === 'datum'" type="date" [label]="m.cimke" label-placement="stacked" [(ngModel)]="ertek[n.id][m.kulcs]"></ion-input>
                <ion-input *ngIf="m.tipus === 'honap'" type="month" [label]="m.cimke" label-placement="stacked" [(ngModel)]="ertek[n.id][m.kulcs]"></ion-input>
                <ion-input *ngIf="m.tipus === 'szoveg'" [label]="m.cimke" label-placement="stacked" [placeholder]="m.sugo || ''" maxlength="200" [(ngModel)]="ertek[n.id][m.kulcs]"></ion-input>
              </ng-container></ng-container>
            </div>
            <div class="gomb">
              <ion-button color="success" (click)="keszit(n)" [disabled]="fut[n.id] || !jogosult || !!hianyzik(n)">
                <ion-icon slot="start" name="document-text-outline"></ion-icon>{{ fut[n.id] ? 'Készül…' : 'PDF' }}
              </ion-button>
            </div>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </ng-container>
  </ng-container>

  <p class="halvany kulso">
    <b>Nem itt készül</b> – tételesen a fenti lefedettségi táblában, okkal: a nemzetiségi bizonyítvány és törzslap, az alapfokú művészeti és a zeneművészeti
    szakgimnázium naplói, az érettségi és a szakmai vizsga nyomtatványai. A kollégiumi nyomtatványok (108. §) nem a 94. § részei.
  </p>
</div>
